import { Container, Row, Col } from "react-bootstrap";
import { useEffect, useState } from "react";
import img1 from "../../../assets/DigitalMarketing/image/login.png";
import logo from "../../../assets/DigitalMarketing/image/Asset 3_whitebg.png";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import "../../../assets/DigitalMarketing/Css/Style.css";
import { IoMailOutline } from "react-icons/io5";
import { TiKeyOutline } from "react-icons/ti";
import { BiClinic } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import { branchLogin, login } from "../../../store/async-actions/auth";
import Toast from "../../../Component/DigitalMarketing/Toast";
import useSnackbar from "../../../hooks/digitalMarketing/useSnackbar";
import Tabs from "../../../Component/DigitalMarketing/Tabs";
import { useGetAllBranchesQuery } from "../../../Service/Masters";
import { createNull } from "typescript";
import {
  useGetAllRolesQuery,
  useGetRoleManagementQuery,
} from "../../../Service/roleManagement";
import { formatWord } from "../../../utils";

interface AccountDetails {
  email: string | null;
  password: string | null;
  hospitalCode: string | null;
  role: number | null | any;
}

interface BranchDetails {
  email: string | null;
  password: string | null;
  hospitalCode: string | null;
  branchId?: number | null; // New field for branch name
  role: number | null | any;
}
const emailValidation = (data: any) => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data);
};

function Login() {
  const [accountDetails, setAccountDetails] = useState<AccountDetails>({
    email: "",
    password: "",
    hospitalCode: "",
    role: null,
  });
  const [branchDetails, setBranchDetails] = useState<BranchDetails>({
    email: "",
    password: "",
    hospitalCode: "",
    branchId: null,
    role: null,
  });

  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);
  const [active, setActive] = useState(1);
  const dispatch = useDispatch<any>();
  const { open, message, openSnackBar, type } = useSnackbar();

  const account = useSelector((state: any) => state.accountDetails);

  const { data, isLoading, refetch } = useGetAllBranchesQuery<any>({
    refetchOnMountOrArgChange: true,
  });

  const { data:RoleData ,refetch:refetchRoles} = useGetAllRolesQuery<any>({
    refetchOnMountOrArgChange: true,
  });
 
  console.log(data?.data, "data");
  const navigate = useNavigate();

  const values = [
    { id: 1, name: "Admin" },
    { id: 2, name: "Branch Staffs" },
  ];

  const submit = async () => {
    console.log(accountDetails,'accountDetails')
    if (
      emailValidation(accountDetails.email) &&
      accountDetails.password &&
      accountDetails.hospitalCode &&
      active === 1
    ) {
      if (accountDetails.email) {
        try {
          const loginPromise = dispatch(
            login({
              email: accountDetails.email,
              password: accountDetails.password,
              hospital_code: accountDetails.hospitalCode,
              role:1
            })
          );

          const timeoutPromise = new Promise((resolve, reject) => {
            setTimeout(() => {
              reject(new Error("Login timeout"));
            }, 8000);
          });

          const success = await Promise.race([loginPromise, timeoutPromise]);

          if (success.meta.requestStatus === "fulfilled") {
            if (success.payload.status !== 500) {
              if (success.payload.token !== undefined) {
                navigate("/");
              } else if (success.payload.data.error) {
                openSnackBar(success.payload.data.error, "error");
              }
            } else {
              openSnackBar(success.payload.data.message, "error");
            }
          } else {
            if (success.payload.data.error !== "") {
              openSnackBar(success.payload.data.error, "error");
            } else if (success.payload.data.message !== "") {
              openSnackBar(success.payload.data.message, "error");
            } else {
              setError(true);
            }
          }
        } catch (error) {
          openSnackBar("Incorrect Hospital Code", "error");
        }
      }
    } else if (
      emailValidation(branchDetails.email) &&
      branchDetails.password &&
      branchDetails.hospitalCode &&
      branchDetails.branchId !== null &&
      active === 2
    ) {
      if (branchDetails.email) {
        try {
          const loginPromise = dispatch(
            branchLogin({
              email: branchDetails.email,
              password: branchDetails.password,
              hospital_code: branchDetails.hospitalCode,
              branchId: branchDetails.branchId,
              role:branchDetails.role
            })
          );

          const timeoutPromise = new Promise((resolve, reject) => {
            setTimeout(() => {
              reject(new Error("Login timeout"));
            }, 8000);
          });

          const success = await Promise.race([loginPromise, timeoutPromise]);
          console.log(success, "success");
          if (success.meta.requestStatus === "fulfilled") {
            if (success.payload.status !== 500) {
              if (success.payload.token !== undefined) {
                navigate("/");
              } else if (success.payload.data.error) {
                openSnackBar(success.payload.data.error, "error");
              }
            } else {
              openSnackBar(success.payload.data.message, "error");
            }
          } else {
            if (success.payload.data.error !== "") {
              openSnackBar(success.payload.data.error, "error");
            } else if (success.payload.data.message !== "") {
              openSnackBar(success.payload.data.message, "error");
            } else {
              setError(true);
            }
          }
        } catch (error) {
          openSnackBar("Incorrect Hospital Code", "error");
        }
      }
    } else {
      setSuccess(true);
    }
  };

  useEffect(() => {
    const clear = setTimeout(() => {
      if (branchDetails.hospitalCode) {
        refetch();
        refetchRoles();
      }
    }, 1000);
    return () => clearTimeout(clear);
  }, [branchDetails.hospitalCode]);

  const onChanging = (event, data) => {
    setError(false);

    const account = active === 1 ? { ...accountDetails } : { ...branchDetails };

    if (data === "password") {
      account.password = event.target.value;
    } else if (data === "code") {
      account.hospitalCode = event.target.value;
      localStorage.setItem("hospitalCode", event.target.value);
    } else if (data == "email") {
      account.email = event.target.value;
    } else if (data === "branchId") {
      account.branchId = event.target.value;
    } else if (data === "role") {
      account.role = event.target.value;
    }

    // Set the updated object
    if (active === 1) {
      setAccountDetails(account);
    } else {
      setBranchDetails(account);
    }
  };

  useEffect(() => {
    if (active) {
      setBranchDetails({
        email: "",
        password: "",
        hospitalCode: "",
        branchId: null,
        role: null,
      });
      setAccountDetails({
        email: "",
        password: "",
        hospitalCode: "",
        role: null,
      });
    }
  }, [active]);

  useEffect(() => {}, []);
  return (
    <Container fluid>
      <Toast open={open} type={type} message={message} />

      <Row className="justify-content-center">
        <Col lg={6} className="img">
          <div className="log-img">
            <img src={img1} />
          </div>
        </Col>
        <Col md={12} lg={6}>
          <div className="log">
            <Row className="justify-content-center">
              <Col xs={10} sm={7} md={7} lg={7}>
                <div className="mt-3">
                  <img
                    className="login-logo mt-5 mb-3"
                    src={logo}
                    alt="logo"
                    width="140"
                  />
                  <h5 className="fw-semibold-log mt-4">Welcome back 🤞</h5>
                  <small>Start managing your clinic faster and better</small>
                </div>
                <Tabs tablist={values} active={active} setActive={setActive} />

                <div className="mt-3 mb-3 d-flex log-input">
                  <span>
                    <IoMailOutline className="log-icon" />
                  </span>
                  <input
                    type="email"
                    onChange={(event) => onChanging(event, "email")}
                    placeholder="you@example.com"
                    className="text-custom-contain-log"
                    style={{ width: "100%" }}
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        submit();
                      }
                    }}
                    name="email"
                  />
                </div>
                {success && accountDetails.email == "" && (
                  <span style={{ color: "red" }}> please enter email</span>
                )}
                {success &&
                  accountDetails.email != "" &&
                  !emailValidation(accountDetails.email) && (
                    <span style={{ color: "red" }}> invalid email</span>
                  )}

                <div className="mb-2 d-flex log-input">
                  <span>
                    <TiKeyOutline className="log-icon" />
                  </span>
                  <input
                    onChange={(event) => onChanging(event, "password")}
                    type="password"
                    placeholder="Password"
                    className="text-custom-contain-log"
                    style={{ width: "100%" }}
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        submit();
                      }
                    }}
                  />
                </div>
                {success && accountDetails.password == "" && (
                  <span style={{ color: "red" }}>
                    please enter your password
                  </span>
                )}
                <div className="mb-2 d-flex log-input">
                  <span>
                    <TiKeyOutline className="log-icon" />
                  </span>
                  <input
                    onChange={(event) => onChanging(event, "code")}
                    type="text"
                    placeholder="hospital code"
                    className="text-custom-contain-log"
                    style={{ width: "100%" }}
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        submit();
                      }
                    }}
                  />
                </div>
                {success && accountDetails.hospitalCode == "" && (
                  <span style={{ color: "red" }}>please enter your code</span>
                )}
                {error && (
                  <span style={{ color: "red" }}>
                    check your email or password
                  </span>
                )}
                {active == 2 && (
                  <>
                    <div className="mb-3 mt-3 d-flex log-input">
                      <span>
                        <BiClinic className="log-icon" />
                      </span>
                      <select
                        onChange={(event) => onChanging(event, "branchId")}
                        className="text-custom-contain-log"
                        style={{ width: "100%" }}
                        placeholder="Select Branch"
                        name="branchId"
                      >
                        <option value="">Select</option>
                        {data?.data?.map((branch) => (
                          <option key={branch.id} value={branch.id}>
                            {branch.branchName}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="mb-3 mt-3 d-flex log-input">
                      <span>
                        <BiClinic className="log-icon" />
                      </span>
                      <select
                        onChange={(event) => onChanging(event, "role")}
                        className="text-custom-contain-log"
                        style={{ width: "100%" }}
                        placeholder="Select Branch"
                        name="branchId"
                      >
                        <option value="">Select</option>
                        {RoleData?.data?.map((branch) => (
                          <option key={branch.id} value={branch.id}>
                            {formatWord(branch.roleName)}
                          </option>
                        ))}
                      </select>
                    </div>
                  </>
                )}
                {/* {success && branchDetails.branchId === null && (
                  <span style={{ color: "red" }}>Please select a branch</span>
                )} */}
                <div className="d-flex justify-content-between align-items-center">
                  <Link
                    to={"/forgot-password"}
                    className="f-16 fw-800 mt-2 text-decoration-none"
                    style={{ color: "#6842D9" }}
                  >
                    Forgot password?
                  </Link>
                </div>
                <Button
                  variant="contained"
                  className="btn d-grid w-100 mt-3"
                  onClick={() => submit()}
                  sx={{
                    textTransform: "none",
                    fontWeight: "bold",
                    background: "#3F7ADD",
                    fontSize: "15px",
                  }}
                >
                  Log in
                </Button>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default Login;
